import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { CommonAction, recipesCommonAction, styledMedia } from '@pkg/primitives';

import BackgroundImage from './assets/images/background.webp';

export const Wrapper = styled(motion.div)`
    display: flex;
    flex-direction: row;

    min-height: 100vh;
    max-width: 100vw;

    flex-grow: 1;
`;

export const ContentColumn = styled.div<{ $hideContent?: boolean }>`
    display: flex;
    width: 50%;
    flex-direction: column;
    flex-grow: 1;

    ${({ $hideContent }) =>
        $hideContent &&
        css`
            display: none;
        `};
`;

export const ContentWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const Background = styled.div<{ $bgImage?: string }>`
    width: 100%;
    min-height: 100vh;

    background-repeat: no-repeat;
    background-size: 100vw 100vh;
    background-position: 0 0;
    background-attachment: fixed;
    background-color: #090719;

    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;

    ${({ $bgImage }) =>
        $bgImage
            ? css`
                  background-image: url(${$bgImage});
              `
            : css`
                  background-image: url(${BackgroundImage});
              `};
`;

export const GuestDrawerAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    // Positioned to be below the "share modal".
    z-index: 98;
    position: absolute;
    top: 16px;
    right: 20px;
    width: 40px;
    height: 40px;
    background-color: rgb(255, 255, 255, 0.1);

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.16);
    }
`;

export const GuestDrawerActionIcon = styled.div`
    ${styledMedia.iconWrapper};
    width: 16px;
    height: 16px;
`;
